import { Injectable } from '@angular/core';

import { seguradorasStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { segurosStorage } from "../../seguros/shared/data.service";
import { SeguroNavigationService } from "../../seguros/shared/seguro-navigation.service";
import { SeguroService } from "../../seguros/shared/seguro.service";

@Injectable()
export class SeguradoraService {

  constructor(
    private _seguroNavigationService: SeguroNavigationService,
    private _seguroService: SeguroService,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(seguradorasStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(seguradorasStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(seguradorasStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === segurosStorage) {
        otherFormObject = this._seguroService.getSessionStorage();
        otherFormObject.seguradora = Response;
        this._seguroService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(seguradorasStorage);

    if (otherForm === segurosStorage) {
      otherFormObject = this._seguroService.getSessionStorage();
      if (otherFormObject.id) {
        this._seguroNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._seguroNavigationService.goToNew();
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/shared/seguradora.service.ts
 **/